// extracted by mini-css-extract-plugin
export default {"main":"add_main__wQmMF","circle":"add_circle__cXIPm","logo":"add_logo__dmUpf","text":"add_text__oTXW-","text_to_left":"add_text_to_left__9N4Qb","btn":"add_btn__Cc2kv"};